"use strict";

$(document).ready(function() {

	viewerUI.init();
});

class ViewerUI {

	init() {

		$("#vr-icon").click(this.onActivateVR);
		$("#fullscreen-icon").click(this.onToggleFullScreen);
		$("#poi-transport").click(this.onTogglePOI);
		$("#poi-culture").click(this.onTogglePOI);
	}

	onActivateVR() {

		viewer.isStereoMode = !viewer.isStereoMode;
		if(viewer.isStereoMode) {
			$(this).addClass("vr-selected");
			viewer.switchRenderMode(viewer.DisplayMode.stereo);

			if(AppTools.hasFullScreenSupport()) {
				AppTools.enableFullScreen();
			}

		} else {
			$(this).removeClass("vr-selected");
			viewer.switchRenderMode(viewer.DisplayMode.normal);

			if(AppTools.hasFullScreenSupport()) {
				AppTools.disableFullScreen();
			}
		}

		viewer.portalController.onVRModeActivated(viewer.isStereoMode);
	}

	onToggleFullScreen() {

		AppTools.toggleFullScreen();
	}

	onTogglePOI(event) {

		let target = $(event.target);
		let tag = $(target).data("options").tag;

		let visible = !viewer.poiVisibilityState.isVisible(tag);

		viewer.togglePOIByCategory(tag, visible);
		viewer.poiVisibilityState.setTagState(tag, visible);

		if(visible) {
			$(target).children('.poi-menu-cell-inactive').hide();
		} else {
			$(target).children('.poi-menu-cell-inactive').show();
		}
	}

	onToggleOverview() {

		viewer.overview.toggleVisibility();
	}

	showUsageInstructions(id, fadeDuration, fadeOutDelay) {

		if(fadeDuration === undefined) fadeDuration = 2000;
		if(fadeOutDelay === undefined) fadeOutDelay = 2000;

		let ins = $(id);

		if (ins.is(':animated')) {
			return;
		}

		ins.css("opacity", "0.0");
		ins.show();
		ins.animate({opacity: 1.0}, fadeDuration,
		function() {
			$(this).delay(fadeOutDelay);
			ins.animate({opacity: 0.0}, fadeDuration)
		})
	}

	updateVisibility() {

		if(viewer.isMobile) {
			$("#vr-icon").show();
			if(AppTools.hasFullScreenSupport()) {
				$("#fullscreen-icon").show();
			}
		} else {
			$('#poi-menu').show();
		}
	}

	showElement(element, visible) {

		if(visible) {
			$(element).show();
		} else {
			$(element).hide();
		}
	}

	showSceneSelection(visible) {

		this.showElement("#scene-menu-container", visible);
	}

	showLogo(visible) {

		this.showElement("#logo", visible);
	}

	showInfo(visible) {

		this.showElement("#info-text", visible);
	}

	populateSceneInfo(header, subtext) {

		let animSpeed = 500;
		let overlayOpacity = 0.75;

		if(!viewer.isMobile) {
			$("#info-text").show();
			$("#info-headline").text(header);
			$("#info-subtext").text(subtext);
		} else {
			$("#info-text").show();
			$("#info-headline").text(header);
			$("#info-modal-content").text(subtext);
			$("#info-icon").show();

			if(viewer.initialLoad) {
				$("#info-icon").on("click", function() {
					let target = $("#info-modal-overlay");
					$(target).show();
					$(target).css("opacity", "0.0");
					$(target).animate({opacity: overlayOpacity, easing: "swing"}, animSpeed);
				});

				$("#info-modal-overlay").on("click", function() {
					$(this).css('opacity', overlayOpacity);
					$(this).animate({opacity: 0.0, easing: "swing"}, animSpeed, function() {
						$(this).hide();
					});
				});
			}
			if(viewer.isStereoMode) {
				this.showInfo(false);
			}

			this.createParentSiteLink(true);
		}
	}

	populateSceneSelection() {

		let scenes = sceneCollection.getAllScenes();
		let container = $("#bottom-ui-panel");
		let menuContainer = "#scene-menu-container";

		container
			.append($("<div id='scene-menu-container'></div>")
			.addClass("scene-selection-container")
		);

		// move the menu to the bottom on mobile
		if(viewer.isMobile) {
			container.css("bottom", "0");
			$(menuContainer).css("margin-left", "0px");
		} else {
			// add the home button on desktop
			let elm = $(menuContainer)
				.append($("<div><div class='scene-selection-cell-label-wrapper'>&nbsp;</div></div>")
				.addClass("scene-selection-cell")
				.addClass("home-button")
				.click(this.onToggleOverview)
				.css('background-image', "url('images/home_button.png')"));
		}

		// add the scene selection buttons
		for(let i=0; i<scenes.length; i++) {
			$(menuContainer)
				.append($("<div><div class='scene-selection-cell-label-wrapper'><span class='scene-selection-cell-label'>" + scenes[i].name +"</span></div></div>")
				.addClass("scene-selection-cell")
				.click({sceneName: scenes[i].name}, (e) => {viewer.loadScene(e)})
				.append($("<div class='scene-selection-cell-bg'></div>")
					.css('background-image', "url('" + scenes[i].previewImage + "')")
				)
				.append($("<div class='scene-selection-cell-overlay'></div>")
					.data("scene", scenes[i].name))
			);
		}

		if(!viewer.isMobile) {
			this.createParentSiteLink(false);
		}
	}

	createParentSiteLink(isMobile=false) {

		let buttonLabel = "TIL PROJEKTSIDEN";
		let targetURL = "http://cphhighline.dk/#sec9";
		let mobileHeaderText = "FORTSÆT 3D RUNDTUR";
		let mobileSuffixText = "(afslut 3D rundtur)";

		if(isMobile) {

			let container = $("#info-modal-content");
			container
				.append($("<p class='site-link-mobile'>" + mobileHeaderText + "</p><br>"))
				.append($("<p><a class='site-link-mobile-border' href='" + targetURL + "'' id='site-link-container' target='_blank'>" + buttonLabel + "</a></p>")
				.append($("<p>" + mobileSuffixText + "</p>"))
			);

		} else {

			let container = $("#bottom-ui-panel");
			container
				.append($("<a href='" + targetURL + "'' id='site-link-container' target='_blank'></a>")
				.addClass("site-link-container")
				.addClass("scale")
			);

			$('#site-link-container')
				.append($("<div>" + buttonLabel + "</div>")
				.addClass("site-link-cell")
				.append($("<div class='site-link-cell-bg'></div>"))
				.append($("<div class='site-link-cell-overlay'></div>"))
			);
		}
	}

	selectActiveScene(target) {

		let targetClass = "scene-selection-cell-overlay";
		let activeClass = "scene-selection-cell-overlay-active";

		// remove selected objects
		$(".scene-selection-cell-overlay").each(function(index) {
			$(this).removeClass(activeClass);
		});

		// check if event originated from the parent
		if(!target.hasClass(targetClass)) {
			target = $(target).children('.' + targetClass);
		}

		target.addClass(activeClass);
		target.css("opacity", "0.0");
		target.animate({opacity: 1.0, easing: "swing"}, 500);
	}

	selectActiveSceneByName(sceneName) {

		let targetClass = "scene-selection-cell-overlay";
		let target = null;

		$(".scene-selection-cell-overlay").each(function(index) {

			if($(this).data("scene").toLowerCase()===sceneName.toLowerCase()) {
				target = $(this);
			}
		});

		this.selectActiveScene(target);
	}

	showMainUI(visible) {

		let target = $("#ui-outer");

		if(visible) {
			target.css("opacity", "0.0");
			target.animate({opacity: 1.0, easing: "swing"}, 1000);
			$(target).show();
		} else {
			target.css("opacity", "1.0");
			$(target).hide();
		}
	}

	createLoadingSpinner() {

		let opts = {
			  lines: 13 // The number of lines to draw
			, length: 28 // The length of each line
			, width: 14 // The line thickness
			, radius: 42 // The radius of the inner circle
			, scale: 0.25 // Scales overall size of the spinner
			, corners: 1 // Corner roundness (0..1)
			, color: '#ffffff' // #rgb or #rrggbb or array of colors
			, opacity: 0.25 // Opacity of the lines
			, rotate: 0 // The rotation offset
			, direction: 1 // 1: clockwise, -1: counterclockwise
			, speed: 1 // Rounds per second
			, trail: 60 // Afterglow percentage
			, fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
			, zIndex: 2e9 // The z-index (defaults to 2000000000)
			, className: 'spinner' // The CSS class to assign to the spinner
			, top: '50%' // Top position relative to parent
			, left: '50%' // Left position relative to parent
			, shadow: false // Whether to render a shadow
			, hwaccel: false // Whether to use hardware acceleration
			, position: 'absolute' // Element positioning
		}

		viewer.spinner = new Spinner(opts);
	}

	showLoadingSpinner(visible) {

		if(viewer.spinner===null) {
			this.createLoadingSpinner();
		}

		let target = document.getElementById("loading-spinner-dynamic");

		if(visible) {
			$(target).show();
			viewer.spinner.spin(target);
		} else {
			$(target).hide();
			viewer.spinner.stop();
		}

		viewer.isLoading = visible;
	}

	mobileCSSRules() {

		let baseClasses = ["logo", "headline", "top-text", "ui-panel"];

		for(let i=0; i<baseClasses.length; i++) {
			//remove default scaling based on media queries
			$("."+baseClasses[i]).removeClass("scale");
			// set specific mobile rules
			$("."+baseClasses[i]).addClass("mobile");
		}
	}

}
